import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import userManager from './userManager';
import PropTypes from 'prop-types'

export class IsAuthenticated extends React.Component {

  render() {
    if (this.props.user !== null) {
      return this.props.children
    }

    else if (this.props.isLoading) {
      return <span>Loading user...</span>
    }

    setTimeout(() => {
      const returnTo = window.location.pathname + window.location.search + window.location.hash
      userManager.signinRedirect({ state: { returnTo } })
    }, 1000)

    return <span>Redirecting to login...</span>
  }
}

IsAuthenticated.propTypes = {
  user: PropTypes.any,
  children: PropTypes.node,
  isLoading: PropTypes.bool
}

IsAuthenticated.defaultProps = {
  user: null,
  children: null,
  isLoading: false
}

const mapStateToProps = state => {
  return {
    isLoading: state.oidc.isLoadingUser,
    user: state.oidc.user,
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IsAuthenticated)



// WEBPACK FOOTER //
// ./src/containers/login/IsAuthenticated.js